import { Typography, Box } from '@mui/material'
import React from 'react'
import { elementStyles } from '../../styles/classes/FormBuilderClasses'
import { faICursor } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { elementIcons } from '../../utils/formBuilder'

const Element = props => {
  const { classes } = elementStyles()
  const { t } = useTranslation()
  return (
    <Box className={classes.container}>
      <Box className={classes.imageContainer}>
        {props.elementKey in elementIcons && (
          <FontAwesomeIcon
            className={`${props.disabled && classes.disabled}`}
            icon={elementIcons[props.elementKey]}
          />
        )}
        {!(props.elementKey in elementIcons) && (
          <FontAwesomeIcon
            icon={faICursor}
            className={`${props.disabled && classes.disabled}`}
          />
        )}
      </Box>
      <Typography
        className={`${classes.text} ${props.disabled && classes.disabled}`}
      >
        {props?.name
          ? props.name
          : t(`form_builder.elements.${props.elementKey}`)}
      </Typography>
    </Box>
  )
}

export default Element
